import { activateUser } from './states';

export const services = {
  activateUser,
};
